import React, { useEffect, useRef, useState } from "react";

/* ---------- Hook: detect when section is active ---------- */
function useInView({ threshold = 0.25, rootMargin = "0px 0px -15% 0px" } = {}) {
  const ref = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      ([entry]) => setActive(entry.isIntersecting),
      { threshold, rootMargin }
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold, rootMargin]);

  return { ref, active };
}

function FOG2026ProgramSchedule() {
  const { ref, active } = useInView();

  const FLYER_IMAGE =
    "https://fogsv.com/wp-content/uploads/2025/12/image-2.jpeg";

  return (
    <>
      <style>{`
        html, body { overflow-x: hidden; }

        /* Subtle reveal animation */
        .fog-content{
          opacity: 0;
          transform: translateY(16px);
          filter: blur(6px);
          transition: opacity 650ms ease, transform 650ms ease, filter 650ms ease;
        }
        .fog-content.is-active{
          opacity: 1;
          transform: translateY(0);
          filter: blur(0);
        }

        .fog-flyer{
          width: 100%;
          max-width: 900px;
          margin: 1.5rem auto 0;
          display: block;
          border-radius: 14px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.35);
        }

        .mt-4{ margin-top: 1.5rem !important; }
      `}</style>

      <section>
        <div className="block color-scheme-4">

          {/* 1) Heading + intro */}
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-9">
                <div className="section-sub-title center">
                  <article
                    ref={ref}
                    className={`section-title-body white fog-content ${
                      active ? "is-active" : ""
                    }`}
                  >
                    <h1 className="head-title hra-topTitle">
                      <span>FOG 2026:</span>{" "}
                      <span>Program Schedule</span>
                    </h1>

                    <p className="hra-topIntro">
                      Plan your day with event timing, venue details, and ticket access.
                    </p>
                  </article>
                </div>
              </div>
            </div>
          </div>

          {/* 2) Flyer Image */}
          <div className="container text-center">
            <img
              src={FLYER_IMAGE}
              alt="FOG 2026 Republic Day Flyer"
              className="fog-flyer"
            />
          </div>

          {/* 3) Main schedule content */}
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-9">
                <div className="section-sub-title center">
                  <article className="section-title-body white">
                    <div className="mt-4">
                      <ul className="white arrow-list">
                        <li><strong>Event:</strong> FOG 77th Republic Day Celebrations</li>
                        <li><strong>Date:</strong> Saturday, January 24, 2026</li>
                        <li><strong>Time:</strong> 12:00 PM – 6:30 PM</li>
                        <li><strong>Venue:</strong> HUSD Performing Arts Center</li>
                        <li><strong>Address:</strong> 2390 Panama St, Hayward, CA 94545</li>
                        <li>
                          <strong>Tickets:</strong>{" "}
                          <a
                            href="https://tinyurl.com/FOGpasses"
                            target="_blank"
                            rel="noreferrer"
                            style={{ color: "#fff", textDecoration: "underline" }}
                          >
                            Buy Tickets
                          </a>
                        </li>
                      </ul>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}

export default FOG2026ProgramSchedule;
